@let abierto = (isExpanded$ | async) || (isMobileOpen$ | async);
<aside
  class="fixed flex flex-col top-0 px-5 left-0 bg-white dark:bg-gray-900 dark:border-gray-800 text-gray-900 h-screen transition-all duration-300 ease-in-out z-50 border-r border-gray-200"
  [ngClass]="{
    'w-[290px]': abierto,
    'w-[90px]': !abierto,
    'translate-x-0': isMobileOpen$ | async,
    '-translate-x-full': !(isMobileOpen$ | async),
    'xl:translate-x-0': true
  }"
>
  <!--Logo start-->
  <!-- Alto fijo: el logo se achica sin mover el menú hacia arriba. -->
  <div class="flex h-20 shrink-0 items-center justify-center">
    <a routerLink="/">
      <img
        src="/assets/images/logos/Logo VT para fondos claros png.png"
        alt="Vitrotech Logo"
        class="block h-auto transition-[width] duration-300 ease-in-out dark:hidden"
        [ngClass]="abierto ? 'w-36' : 'w-12'"
      />
      <img
        src="/assets/images/logos/Logo VT para fondos oscuros png.png"
        alt="Vitrotech Logo"
        class="hidden h-auto transition-[width] duration-300 ease-in-out dark:block"
        [ngClass]="abierto ? 'w-36' : 'w-12'"
      />
    </a>
  </div>
  <!--Logo end-->

  <div class="flex flex-col overflow-x-hidden overflow-y-auto no-scrollbar">
    <!-- 2026-09-23: todos los destinos a un clic, agrupados por uso (antes, un acordeón por módulo). -->
    <nav class="mb-6" aria-label="Menú principal">
      <div class="flex flex-col gap-5">
        @for (section of sections(); track section.title) {
          <div>
            <h2 class="relative mb-2 h-5 text-xs uppercase leading-[20px] tracking-wide text-gray-500 dark:text-gray-400">
              <span class="block whitespace-nowrap transition-opacity" [ngClass]="abierto ? 'opacity-100 duration-200 delay-100' : 'opacity-0 duration-100'">{{ section.title }}</span>
              <span class="absolute top-1/2 left-3 h-px w-6 bg-gray-200 transition-opacity dark:bg-gray-700" aria-hidden="true"
                [ngClass]="abierto ? 'opacity-0 duration-100' : 'opacity-100 duration-200 delay-100'"></span>
            </h2>
            <ul class="flex flex-col gap-1">
              @for (nav of section.items; track nav.path) {
                <li>
                  <a
                    [routerLink]="nav.path"
                    (click)="onItemClick()"
                    class="menu-item group overflow-hidden"
                    [ngClass]="isActive(nav.path) ? 'menu-item-active' : 'menu-item-inactive'"
                    [attr.aria-current]="isActive(nav.path) ? 'page' : null"
                    [matTooltip]="nav.name"
                    [matTooltipDisabled]="abierto"
                    matTooltipPosition="right"
                    [matTooltipShowDelay]="0"
                    [matTooltipHideDelay]="0"
                  >
                    <mat-icon
                      class="menu-item-icon-size material-icons-outlined shrink-0 overflow-visible!"
                      [svgIcon]="nav.iconType === 'svg' ? nav.icon : ''"
                      [ngClass]="isActive(nav.path) ? 'menu-item-icon-active' : 'menu-item-icon-inactive'"
                    >
                      @if (nav.iconType !== 'svg') {
                        {{ nav.icon }}
                      }
                    </mat-icon>
                    <span class="menu-item-text whitespace-nowrap transition-opacity"
                      [ngClass]="abierto ? 'opacity-100 duration-200 delay-100' : 'opacity-0 duration-100'">{{ nav.name }}</span>
                  </a>
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </nav>
  </div>

  <!-- Contraer/expandir en escritorio; en el celular el menú se abre desde el header. -->
  <div class="mt-auto hidden border-t border-gray-200 py-4 dark:border-gray-800 xl:block">
    <button
      type="button"
      (click)="sidebarService.toggleExpanded()"
      class="menu-item menu-item-inactive group overflow-hidden"
      [attr.aria-label]="abierto ? 'Contraer menú' : 'Expandir menú'"
      matTooltip="Expandir menú"
      [matTooltipDisabled]="abierto"
      matTooltipPosition="right"
      [matTooltipShowDelay]="0"
      [matTooltipHideDelay]="0"
    >
      <mat-icon class="menu-item-icon-inactive shrink-0 transition-transform duration-300 ease-in-out"
        [ngClass]="{ 'rotate-180': !abierto }">keyboard_double_arrow_left</mat-icon>
      <span class="menu-item-text whitespace-nowrap transition-opacity"
        [ngClass]="abierto ? 'opacity-100 duration-200 delay-100' : 'opacity-0 duration-100'">Contraer menú</span>
    </button>
  </div>
</aside>
